// Copyright (c) 2017 Deere & Company

export default {
    name: 'OPEN_PIPS',
    onEnter: (nextState, replace) => replace('/pips/open-pips'),
    path: 'open-pips'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/reports/open-pips.js